// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:32:36

export default {
  "id": "gun-rush-1",
  "slug": "gun-rush-1",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/e0ee0fc8416845b992af13f0bc74375d-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/e0ee0fc8416845b992af13f0bc74375d/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Gun Rush",
      "description": "Fire off your epic selection of awesome guns to reach the end of each level while causing chaos and destruction! Amass coins to unlock more guns across endless levels of utter carnage!!!!! (╯°□°）╯︵ ┻━┻",
      "instructions": "Simply tap, click or press enter to shoot and move in the opposite direction you fire!",
      "genres": [
        "Agility",
        "Shooter"
      ],
      "tags": [
        "arcade",
        "explosion",
        "guns",
        "gunslinger",
        "score"
      ]
    },
    "zh-CN": {
      "title": "枪袭",
      "description": "发射你史诗级的强大枪械，在造成混乱和破坏的同时完成每个关卡！积累硬币解锁更多枪械，横扫无尽破坏的关卡！！！！！（╯°□°）╯︵ ┻━┻",
      "instructions": "轻轻点击、点击或按回车键射击，并移动到射击方向的反方向！",
      "genres": [
        "敏捷性",
        "射击"
      ],
      "tags": [
        "街机",
        "爆炸",
        "枪械",
        "枪客",
        "得分"
      ]
    },
    "zh-TW": {
      "title": "槍擊狂潮",
      "description": "發射你強大的武器選擇，穿越每個關卡的最後，造成混亂和破壞！積累硬幣以解鎖更多武器，在無盡的殘酷關卡中戰鬥!!!!! (╯°□°）╯︵ ┻━┻",
      "instructions": "只需輕觸、點擊或按Enter鍵即可射擊，並向射擊方向相反移動！",
      "genres": [
        "敏捷性",
        "射手"
      ],
      "tags": [
        "街機",
        "爆炸",
        "槍",
        "槍客",
        "分數"
      ]
    },
    "zh-HK": {
      "title": "槍戰狂潮",
      "description": "發射你經典選擇的強大槍械，在每個關卡結束時造成混亂和毀滅！累積硬幣以解鎖更多槍械，穿越無盡的殘酷關卡!!!!! (╯°□°）╯︵ ┻━┻",
      "instructions": "輕輕觸碰、點擊或按Enter鍵即可射擊，並向反方向移動！",
      "genres": [
        "靈巧度",
        "射手"
      ],
      "tags": [
        "街機",
        "爆炸",
        "槍械",
        "槍客",
        "得分"
      ]
    },
    "ja": {
      "title": "ガン・ラッシュ",
      "description": "各種素晴らしい銃を選んで、各レベルを終えるために混乱と破壊を引き起こしながら突進せよ！コインを集めて、無限の殺戮のレベルでさらに銃を解禁しよう！(╯°□°）╯︵ ┻━┻",
      "instructions": "単にタップ、クリック、またはエンターキーを押して撃つそして発射方向の反対側に移動！",
      "genres": [
        "敏捷性",
        "シューティング"
      ],
      "tags": [
        "アーケード",
        "爆発",
        "銃",
        "ガンслァイガー",
        "スコア"
      ]
    },
    "ko": {
      "title": "건 러시",
      "description": "각 단계의 끝까지 도달하기 위해 위대한 무기를 발사하고 혼란과 파괴를 일으키세요! 동전을 모아 더 많은 무기를 해금하세요! 끝없는 무참한 혼란의 단계에서 더 많은 무기를 얻으세요!!!!! (╯°□°）╯︵ ┻━┻",
      "instructions": "쉽게 탭, 클릭 또는 엔터를 눌러 쏘고 발사 방향의 반대 방향으로 이동하세요!",
      "genres": [
        "민첩성",
        "총기射手"
      ],
      "tags": [
        "아케이드",
        "폭발",
        "총",
        "총사",
        "점수"
      ]
    },
    "fr": {
      "title": "Course d'armes",
      "description": "Foncez avec votre sélection épique d'armes incroyables pour atteindre la fin de chaque niveau tout en causant le chaos et la destruction ! Amassez des pièces pour débloquer plus d'armes sur des niveaux interminables de carnage!!! (╯°□°）╯︵ ┻━┻",
      "instructions": "Touchez, cliquez ou appuyez sur Entrée pour tirer et vous déplacer dans la direction opposée à votre tir !",
      "genres": [
        "Agilité",
        "tireur"
      ],
      "tags": [
        "arcade",
        "explosion",
        "armes",
        "gunslinger",
        "score"
      ]
    }
  }
};
